import { createContext, ReactElement, useContext, useState } from 'react'

type ModalBoxContextProps = {
  open: boolean
  setOpen: any
  content: any
  setContent: any
  modalBox: any
  customModalClose: any
  setCustomModalClose: any
  title: any
  setTitle: any
  width: string
  height: string
  modalClose: any
  noCloseButton: boolean
}

type ModalBoxProviderProps = {
  children: ReactElement
}

const ModalBoxContext = createContext<ModalBoxContextProps>(
  {} as ModalBoxContextProps
)

export const ModalBoxProvider = ({ children }: ModalBoxProviderProps) => {
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState<any>(null)
  const [title, setTitle] = useState<string | null>(null)
  const [customModalClose, setCustomModalClose] = useState(null)
  const [width, setWidth] = useState<string>('')
  const [height, setHeight] = useState<string>('')
  const [noCloseButton, setNoCloseButton] = useState(false)

  const modalBox = (
    ctt: any,
    title: string | null,
    width: string,
    height: string,
    noCloseButton: boolean
  ) => {
    setNoCloseButton(noCloseButton)
    setOpen(true)
    setContent(ctt)
    setTitle(title)
    setWidth(width)
    setHeight(height)
  }

  const modalClose = () => {
    setOpen(false)
    setContent(null)
    setTitle(null)
  }

  return (
    <ModalBoxContext.Provider
      value={{
        open,
        setOpen,
        content,
        setContent,
        modalBox,
        customModalClose,
        setCustomModalClose,
        title,
        setTitle,
        width,
        height,
        modalClose,
        noCloseButton
      }}
    >
      {children}
    </ModalBoxContext.Provider>
  )
}

export const useModalBox = () => {
  const context = useContext(ModalBoxContext)

  if (!context)
    throw new Error(
      'useModalBox must be used within a provider ModalBoxProvider'
    )

  return { ...context }
}
